import AudienceIcon from '../components/icons/AudienceIcon';
import { getRate } from './products';

type EnhancementPackage = {
  packageName: string;
  productKey?: string;
  rate: number;
  descriptionShort: string;
  descriptionLong: string;
  variablesIncluded: string[];
  componentType: string;
  icon: JSX.Element;
  additionalDescription?: JSX.Element;
};
// todo - the getRate needs to return an actual value for this to work. Since for these new defaut enhancements
// todo - we don't have a product key and aiq will not use stripe, all the rates will be 0 and defaulted to identifiers.'
const enhancementPackages: EnhancementPackage[] = [
  {
    packageName: 'Analytics Bundle',
    productKey: 'analyticsBundle',
    rate: getRate('identifiers'),
    descriptionShort:
      'Fuel advanced modeling and analytics with high-value predictive variables.',
    descriptionLong:
      'Fuel advanced modeling and analytics with high-value predictive variables.',
    variablesIncluded: [''],
    componentType: 'default',
    icon: <AudienceIcon />,
  },
  {
    packageName: 'Foundation',
    productKey: 'foundation',
    rate: getRate('identifiers'),
    descriptionShort: 'Gain a high level perspective of your audience with common attributes like age, gender, income and more.',
    descriptionLong: 'Gain a high level perspective of your audience with common attributes like age, gender, income and more.',
    variablesIncluded: [
      'marital_status',
      'age',
      'gender',
      'children_present_hh',
      'pet_owner',
      'life_event_parent',
      'education',
      'occupation',
      'hh_income',
    ],
    componentType: 'default',
    icon: <AudienceIcon />,
  },
  {
    packageName: 'SDOH and Health',
    productKey: 'SDOH and Health',
    rate: getRate('identifiers'),
    descriptionShort: 'Enhance healthcare strategies with insights into the non-clinical factors shaping consumer well-being.',
    descriptionLong: 'Enhance healthcare strategies with insights into the non-clinical factors shaping consumer well-being.',
    variablesIncluded: [''],
    componentType: 'default',
    icon: <AudienceIcon />,
  },
  {
    packageName: 'BusinessCore Contacts',
    productKey: 'businessCoreContacts',
    rate: getRate('identifiers'),
    descriptionShort: 'Gain a deeper view of professionals — beyond the workplace — to drive more personalized engagement.',
    descriptionLong: 'Gain a deeper view of professionals — beyond the workplace — to drive more personalized engagement.',
    variablesIncluded: [""],
    componentType: 'default',
    icon: <AudienceIcon />,
  },
  {
    packageName: 'FLA-Friendly',
    productKey: 'flaFriendly',
    rate: getRate('identifiers'),
    descriptionShort: 'Consumer data designed for safe use in financial services marketing — excludes sensitive attributes to support regulatory compliance.',
    descriptionLong: 'Consumer data designed for safe use in financial services marketing — excludes sensitive attributes to support regulatory compliance.',
    variablesIncluded: [""],
    componentType: 'default',
    icon: <AudienceIcon />,
  },
];

export default enhancementPackages;
